import React, { Component } from "react";
import { Alert, Button, Row, Col } from "reactstrap";
import constants from "../../../../utils/constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExclamationTriangle,
  faCheckCircle,
  faTimesCircle
} from "@fortawesome/free-solid-svg-icons";

const URL_BASE = `${constants.BASE_URL}/${constants.DOCUMENTS_BASE_URL}/`;

interface Props {
  storage: string;
  resolucion: boolean;
  razonamiento: string;
  nombre: string;
  onClose: () => void;
}

interface State {}

export default class DocumentoInvalidoComponent extends Component<
  Props,
  State
> {
  state = {};

  render() {
    const { onClose, resolucion, razonamiento, storage, nombre } = this.props;

    return (
      <div style={{ marginRight: "15px" }}>
        <Row>
          {/* Columna izquierda: Información del error */}
          <Col md={4}>
            <div style={{ maxHeight: "600px", overflowY: "auto" }}>
              {/* Estado del documento */}
              <Alert color={resolucion ? "success" : "danger"}>
                <div className="text-center mb-3">
                  <FontAwesomeIcon
                    icon={resolucion ? faCheckCircle : faExclamationTriangle}
                    size="2x"
                  />
                </div>
                <h5 className="text-center mb-3">
                  {resolucion ? "Documento Válido" : "Documento No Válido"}
                </h5>
                {nombre && <p className="mb-2 text-center">{nombre}</p>}
              </Alert>

              {/* Razonamiento */}
              <div className="mt-4">
                <div
                  style={{
                    padding: "15px",
                    backgroundColor: "#f8f9fa",
                    borderRadius: "5px",
                    border: "1px solid #dee2e6"
                  }}
                >
                  <p style={{ whiteSpace: "pre-wrap", marginBottom: 0 }}>
                    {razonamiento ||
                      "No se proporcionó información adicional sobre la verificación."}
                  </p>
                </div>
              </div>

              {/* Botón de cierre */}
              <div className="text-right mt-4">
                <Button color="secondary" onClick={onClose} size="sm">
                  Cerrar
                </Button>
              </div>
            </div>
          </Col>

          {/* Columna derecha: Visor del documento */}
          <Col
            md={8}
            style={{
              background: "#444",
              color: "#fff"
            }}
          >
            {storage ? (
              <div style={{ margin: "0 -15px" }}>
                <iframe
                  src={`${URL_BASE}${storage}`}
                  style={{
                    width: "100%",
                    height: "600px",
                    border: "1px solid #444"
                  }}
                  title="Documento"
                />
              </div>
            ) : (
              <div className="text-center p-5">
                <h5>No hay documento disponible para visualizar</h5>
              </div>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}
